export function adaptInboundResponse({ payload, topic }) {
  const normalizedTopic = String(topic || '').trim()
  if (!normalizedTopic) return null
  if (normalizedTopic.includes('/resp/')) return null

  const parts = normalizedTopic.split('/')
  const leaf = String(parts[parts.length - 1] || '')
    .trim()
    .toLowerCase()
  const baseTopic = parts.slice(0, -1).join('/')
  if (!baseTopic) return null

  if (
    leaf === 'config' &&
    payload &&
    typeof payload === 'object' &&
    payload.config
  ) {
    return {
      payload: {
        data: payload.config,
      },
      topic: `${baseTopic}/resp/config/read/legacy`,
    }
  }

  if (leaf === 'log' && payload && typeof payload === 'object' && payload.log) {
    return {
      payload: {
        data: payload.log,
      },
      topic: `${baseTopic}/resp/log/read/legacy`,
    }
  }

  return null
}

export function adaptOutboundCommand({
  action,
  baseTopic,
  clientFormat,
  data = {},
  type,
}) {
  if (clientFormat !== 'legacy') return null

  const normalizedType = String(type || '')
    .trim()
    .toLowerCase()
  const normalizedAction = String(action || '')
    .trim()
    .toLowerCase()
  const normalizedBaseTopic = String(baseTopic || '').trim()
  if (!normalizedBaseTopic) return null

  if (normalizedAction === 'read' && normalizedType === 'config') {
    return {
      payload: {
        filepath: String(data?.filepath || ''),
      },
      topic: `${normalizedBaseTopic}/get-config`,
    }
  }

  if (normalizedAction === 'read' && normalizedType === 'log') {
    return {
      payload: {
        filepath: String(data?.filepath || ''),
      },
      topic: `${normalizedBaseTopic}/get-log`,
    }
  }

  if (normalizedAction === 'write' && normalizedType === 'config') {
    return {
      payload: {
        content: String(data?.content || ''),
        filepath: String(data?.filepath || ''),
      },
      topic: `${normalizedBaseTopic}/set-config`,
    }
  }

  if (normalizedAction === 'clear' && normalizedType === 'log') {
    return {
      payload: {
        filepath: String(data?.filepath || ''),
      },
      topic: `${normalizedBaseTopic}/clear-log`,
    }
  }

  if (normalizedAction === 'open' && normalizedType === 'app') {
    return {
      payload: {
        target_name: String(data?.target_name || ''),
      },
      topic: `${normalizedBaseTopic}/open`,
    }
  }

  if (normalizedAction === 'close' && normalizedType === 'app') {
    return {
      payload: {
        target_name: String(data?.target_name || ''),
      },
      topic: `${normalizedBaseTopic}/close`,
    }
  }

  if (normalizedAction === 'restart' && normalizedType === 'agent') {
    return {
      payload: {},
      topic: `${normalizedBaseTopic}/restart`,
    }
  }

  if (normalizedAction === 'reboot' && normalizedType === 'system') {
    return {
      payload: {},
      topic: `${normalizedBaseTopic}/reboot`,
    }
  }

  if (normalizedAction === 'update' && normalizedType === 'agent') {
    return {
      payload: {
        zip_url: String(data?.zip_url || ''),
      },
      topic: `${normalizedBaseTopic}/client-update`,
    }
  }

  return null
}
